module.exports = __webpack_public_path__ + "img/REGIME_ALIMENTAIRE_ACTIVE.e0866a25.svg";